var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "performance-marketing-section",
    { attrs: { title: "Why Adfound?" } },
    [
      _c("div", { staticClass: "_flexcol _gap-6" }, [
        _c(
          "div",
          {
            staticClass:
              "_grid _grid-cols-1 _grid-cols-2--m _grid-cols-3--l _gap-6",
          },
          _vm._l(_vm.benefits, function (benefit) {
            return _c(
              "div",
              { key: benefit.title, staticClass: "_flexcol _gap-2 _tac" },
              [
                _c(
                  "div",
                  { staticClass: "_px-3" },
                  [
                    _c("base-icon", {
                      staticClass: "_tc--accent",
                      attrs: { name: benefit.icon, size: "3x" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h5", { staticClass: "gfu-hd gfu-hd--h4" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(benefit.title) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(benefit.description) +
                      "\n                "
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "_flex _jc-c" },
          [
            _c(
              "base-button",
              { attrs: { theme: "accent" }, on: { click: _vm.onTryForFree } },
              [_vm._v("\n                Try Adfound\n            ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }